import React, { useState, useEffect } from "react";
import axios from "axios";

const Latestnews = () => {
  const [latestNews, setLatestNews] = useState([]);

  useEffect(() => {
    const fetchLatestNews = async () => {
      try {
        const response = await axios.get(
          "https://arabic-news-api.p.rapidapi.com/cnnarabic",
          {
            headers: {
              "x-rapidapi-key": "21de8334e4msh1a4aea180805afbp1a7f42jsn6060c3c961db", // Replace with your actual API key
              "x-rapidapi-host": "arabic-news-api.p.rapidapi.com",
            },
          }
        );

        // Sort news by published date in descending order
        const sortedNews = response.data.results.sort(
          (a, b) => new Date(b.publishedAt) - new Date(a.publishedAt)
        );
        // Update state with the latest three news articles
        setLatestNews(sortedNews.slice(0, 3));
      } catch (error) {
        console.error("Error fetching news:", error);
      }
    };

    fetchLatestNews();
  }, []);

  return (
    <div className="news-container">
      <h1 className="title">أحدث الأخبار</h1>
      <div className="news-grid">
        {latestNews.map((article, index) => (
          <div key={index} className="news-card">
            {article.image && (
              <img
                src={article.image}
                alt={article.headline}
                className="news-image"
              />
            )}
            <div className="news-content">
              <h2 className="news-title">
                {article.headline || "No Title"}
              </h2>
              <p className="news-description">
                {article.underHeadline || "No Description"}
              </p>
              <p className="news-date">
                <strong>Date:</strong> {article.date || "Unknown"}
              </p>
              <a
                href={article.url}
                target="_blank"
                rel="noopener noreferrer"
                className="news-link"
              >
                Read more
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Latestnews;
